import styled from 'styled-components';

const FlexContent = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  ${(props) => (props.spaceEvenly ? 'justify-content: space-evenly' : '')}
  @media(max-width: 1000px) {
    flex-direction: column;
  }
`;

export default FlexContent;
